var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.424 8 .524.883 5.722 9.637 3.605 4.806.725.967h-5.135v.01l-.008-.01H1l.846-.995 5.116-6.02 4.213-6.017.426-.609.51.544 3.977 4.242 3.82-6.55.517-.886zm8.16 15.085h-2.719V19.46l2.719 3.625zm-4.048-5.793.725 1.221v3.957l-4.165-5.636 3.441.458zm-3.805-6.41 3.413 5.749-3.412-.454v-5.293zm-4.008 5.862 3.405-5.836v5.11l-.064.068-.3-.04.148.202-3.645 3.89.231-3.007.226-.386zm-.963.11.158.168-.02-.001-.247 3.23-2.386-2.626.006-.01-.179-.18-1.42-1.421V12.66l.068-.097 4.021 4.29zm-4.695-3.33v2.427L8.451 17.26l2.615-3.734zM6.72 19.429l.93-1.096 3.658-1.829 1.177 1.178-3.782 5.402H8.67l-1.95-3.656zm-.42.494 1.685 3.16H3.613l2.686-3.16zm6.608-1.793-3.467 4.955h4.78l1.3-2.08-2.612-2.874zm6.614 4.955h-4.59l1.148-1.836 3.442 1.835zm5.443 0h-4.159l-4.317-2.303 3.786-4.04 4.689 6.343z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMith);
export default __webpack_public_path__ + "static/media/MITH.17860a112fd4ac7dd394ddc700521ffb.svg";
export { ForwardRef as ReactComponent };